export default __webpack_public_path__ + "static/media/Custom-HUD-Header (2 Layers).6c3b495b.jpg";